import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { api } from "../../../services/apiService";
import { apiMessage } from "../apiMessage";
import { AuthLayout } from "../components/AuthLayout";

export function RegisterPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ firstName: "", lastName: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (auth.isAuthenticated) return <Navigate to="/dashboard" replace />;

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      const response = await api.post("/auth/register", form);
      auth.signIn(response.data);
      navigate(location.state?.from || "/dashboard");
    } catch (err) {
      setError(apiMessage(err, "Unable to create your account"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout
      eyebrow="Parent account"
      title="Create your account"
      subtitle="Register to book sessions, track assessments, and manage memberships for your players."
    >
      <form onSubmit={submit} className="auth-form">
        <div className="auth-form-row">
          <div>
            <label className="ops-form-label">First name</label>
            <input
              required
              className="ops-input"
              value={form.firstName}
              onChange={(e) => setForm({ ...form, firstName: e.target.value })}
            />
          </div>
          <div>
            <label className="ops-form-label">Last name</label>
            <input
              required
              className="ops-input"
              value={form.lastName}
              onChange={(e) => setForm({ ...form, lastName: e.target.value })}
            />
          </div>
        </div>

        <div>
          <label className="ops-form-label">Email address</label>
          <input
            required
            type="email"
            className="ops-input"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
        </div>

        <div>
          <label className="ops-form-label">Password</label>
          <input
            required
            minLength={8}
            type="password"
            className="ops-input"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />
          <span className="ops-form-hint">At least 8 characters.</span>
        </div>

        {error && <div className="ops-alert ops-alert--error">{error}</div>}

        <button type="submit" className="ops-button ops-button--primary auth-submit" disabled={submitting}>
          {submitting ? "Creating account…" : "Create account"}
        </button>
      </form>

      <div className="auth-footer">
        <span>Already have an account?</span>
        <Link to="/login">Sign in</Link>
      </div>
    </AuthLayout>
  );
}
